module.exports = __webpack_public_path__ + "static/media/epargn-policy-number.1c948e7a.png";